<div [formGroup]="formGroup" class="reservation-service-tile-form-container">
  <div class="row no-gutters">
    <div class="col-auto">
      <mat-checkbox
        #tile
        aria-label="selectServiceCategory"
        [checked]="formGroup.controls.isSelected.value"
        [disabled]="!canCategoryBeSelected()"
        (change)="tile.checked !== formGroup.controls.isSelected.value && toggleCategory()"
        (keyup.enter)="canCategoryBeSelected() && toggleCategory()"
        style="margin-right: 0.625rem"
      ></mat-checkbox>
    </div>
    <ng-container *ngIf="serviceCategory">
          <div
            (click)="canCategoryBeSelected() && toggleCategory()"
            class="lato bold primary pt-1 col clickable"
            [ngClass]="{ 'disabled-text': !canCategoryBeSelected() }"
          >
            <span>{{ serviceCategory.categoryName }}</span>
          </div>
          <div class="service-info-table col-1 pt-1">
            <div
              *ngIf="formGroup.controls.isSelected.value && +formGroup.controls.totalPrice.value >0"
              class="reservation-service-price oswald"
            >
              {{ +formGroup.controls.totalPrice.value | currency }}
            </div>
          </div>
    </ng-container>
    </div>
        <div *ngIf="formGroup.controls.isSelected.value">
          <div *ngFor="let element of serviceFormArray.controls; let i = index">
            <div class="row no-gutters">
              <div class="col-auto pr-2">
                <mat-checkbox
                  *ngIf="serviceCategory.multiSelectable"
                  #elem
                  aria-label="selectService"
                  [checked]="element.value.isSelected"
                  (change)="
                    elem.checked !== element.value.isSelected &&
                      toggleService(i)
                  "
                  (keyup.enter)="toggleService(i)"
                ></mat-checkbox>
                <mat-radio-button
                  *ngIf="!serviceCategory.multiSelectable"
                  #radioElem
                  aria-label="selectService"
                  [name]="serviceCategory.categoryName"
                  [checked]="element.value.isSelected"
                  (change)="
                    radioElem.checked !== element.value.isSelected &&
                      toggleService(i)
                  "
                ></mat-radio-button>
              </div>
              <div class="col service-tile-form-content pt-1">
                <span class="clickable" (click)="toggleService(i)">
                  <span>{{ element.value.name }}</span>
                  <span *ngIf="element.value?.description"
                    class="service-description">{{ element.value.description }}</span>
                </span>
                <div
                  *ngIf="isErrorOnSave && selectedServiceIndex !== i"
                  class="row no-gutters"
                ></div>
              </div>
              <div class="service-info-table col-1 pt-1">
                <div
                  class="
                    reservation-service-price reservation-service-price-small
                    oswald
                  "
                >
                  {{ element.value.price | currency }}
                </div>
              </div>
            </div>
        </div>
    </div>
</div>
